import { useSelector } from "react-redux";
import { clientSelector } from "@/redux/clients/clients.selector";
import { useDuaDocumentsColumns, DuaDocumentsColumns } from "./columns";
import DataTableDuaDocuments from "./data-table";
import { DocumentoNoComercial } from "@/redux/clients/types/Clients.interface";
import { TableSkeleton } from "@/components/ui/loading";

const InvoicingDataPage = () => {
  const { folderData, loading } = useSelector(clientSelector).ui;
  const columnsDuaDocuments = useDuaDocumentsColumns();

  const dataDuaDocuments =
    (folderData &&
      folderData.carpetas[0].documentosNoComerciales.map(
        (document: DocumentoNoComercial) => ({
          numero: document.tipoDocumento + "-" + document.nroDocumento,
          nroInterno: document.nroInternoRade,
        }),
      )) ||
    [];

  return (
    <div className="container pb-2 mt-2 w-full">
      {loading ? (
        <TableSkeleton rows={6} columns={3} />
      ) : (
        <DataTableDuaDocuments
          columns={columnsDuaDocuments}
          data={dataDuaDocuments as DuaDocumentsColumns[]}
        />
      )}
    </div>
  );
};

export default InvoicingDataPage;
